import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcLogout(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.25 11.827V3.75q0-.32.215-.535A.73.73 0 0 1 12 3q.32 0 .535.215a.73.73 0 0 1 .215.535v8.077a.73.73 0 0 1-.215.534.73.73 0 0 1-.535.216.73.73 0 0 1-.535-.216.73.73 0 0 1-.215-.534"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.161 6.171A.75.75 0 0 0 5.1 5.111 9.72 9.72 0 0 0 2.25 12c0 5.385 4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75a9.72 9.72 0 0 0-2.713-6.748.75.75 0 0 0-1.082 1.038A8.25 8.25 0 1 1 6.162 6.17"
  }));
}
var IcLogout = createNolIcon(/*#__PURE__*/forwardRef(SvgIcLogout));

export { IcLogout as I };
